import React from "react";
import translate from "../../../../i18n/translate";
import { getRandomNumber } from "../../../shared/utils/sharedUtils";
import { Accordion, AccordionDetails, AccordionSummary, Card, CardContent } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ProgressBar from "../../ProgressPage/ProgressBar";
import { getDateAndTimeFormat, getSessionStatus } from "./utils";
import Badges from "./Badges";
import { CourseData, LevelDetail, TotalUnit } from "../ProgressDetailsInterfaces";
import CertificatesBlock from "./CertificatesBlock";
import "./LevelDetails.scss"

interface LevelDetailsProps {
  data: LevelDetail;
  activeLevel: Level;
  courseData: CourseData
}
interface Level {
  title: string;
  id: string;
  level: string;
}
const LevelDetails = (props: LevelDetailsProps) => {
  const { courseReport } = props.data;

  return (
      <div className="part-container">
        <div className="part-details-wrap">
          <Card>
            <CardContent>
              <div className="level-main-card">
                <div className="completion-number">{courseReport.moduleTotalExercisesPercent}%</div>
                <div className="completion-label completed-text">
                  {translate("progress_overall_card_title_prework")}
                </div>
              </div>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <div className="level-main-card">
                <div className="completion-number">
                  ({courseReport.sessionCompletedInUnits}/{courseReport.totalSessionInUnits})
                </div>
                <div className="completion-label completed-text">
                  {translate("progress_overall_card_title_session")}
                </div>
              </div>
            </CardContent>
          </Card>
          <Badges data={courseReport.badge} activeLevel={props.activeLevel} />
          <CertificatesBlock data={courseReport.certificate} activeLevel={props.activeLevel} certificateData={props.courseData} />
        </div>

        <div className="module-wrap">
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div className="module-container">
                <div className="module-title">{props.data.coursetitle}</div>

                <div className="module-detail-container">
                  <div className="prework-wrap">
                    <div className="module-type">{translate("progress_overall_card_title_prework")}</div>
                    <div className="calculation-wrap">{` ${courseReport.moduleTotalExercisesPercent}%  (${courseReport.exercisesAttendInUnits}/${courseReport.totalExercisesInUnits})`}</div>
                  </div>
                  <div className="session-wrap">
                    <div className="session-details">{translate("progress_overall_card_title_session")}</div>
                    <div className="calculation-wrap">{` ${courseReport.moduleSessionCompletedPercent}%  (${courseReport.sessionCompletedInUnits}/${courseReport.totalSessionInUnits})`}</div>
                  </div>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <>
                {courseReport.totalUnits &&
                  courseReport?.totalUnits.map((courseUnit: TotalUnit, index: number) => (
                    <div key={getRandomNumber(index)}>
                      <Card className="subskill-card">
                        <CardContent>
                          <div className="subskill-content-container">
                            <div className="subskill-title">{courseUnit.unitTitle}</div>
                            <div className="subskill-list-body">
                              <div className="subskill-progress-block  unit-details-wrap">
                                <div className="subskill-progress-block-1 unit-progress-container">
                                  <div className="subskill-progress-label">
                                    {translate("progress_subskill_preworkTitle")}
                                  </div>
                                  <div className="subskill-progress-bar">
                                    <ProgressBar
                                      progressPercentage={Math.round(
                                        (courseUnit.exercises.totalAttened / courseUnit.exercises.totalExercises) * 100
                                      )}
                                    ></ProgressBar>
                                  </div>
                                  <div className="unit-details-progress">
                                    {Math.round(
                                      (courseUnit.exercises.totalAttened / courseUnit.exercises.totalExercises) * 100
                                    )}
                                    % ({courseUnit.exercises.totalAttened}/ {courseUnit.exercises.totalExercises})
                                  </div>
                                </div>
                                {courseUnit.session.hasSession && (
                                  <div>
                                    <div>{translate("progress_subskill_sessionTitle")}</div>
                                    <span className="session-text-completed">{getSessionStatus(courseUnit.session)}</span>
                                    <div className="session-text-starttime">
                                      {getDateAndTimeFormat(courseUnit.session?.sessionStart)}
                                    </div>
                                  </div>
                                )}
                                {!courseUnit.session.hasSession && (
                                  <span className="sess-text">
                                    {translate("progress_subskill_sessionStatusNoSessions")}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                  ))}
              </>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>   
  );
};

export default LevelDetails;
